import { ProjectComponent } from "../components/Project/projectComponent";

export const ProjectPublic = () => {
    return (
        <ProjectComponent isPublic={true}></ProjectComponent>
    );
};